package com.sweetlime.bingeamigo.presentation.features.review

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.sweetlime.bingeamigo.model.UserReview
import com.sweetlime.bingeamigo.model.types.ContentType
import com.sweetlime.bingeamigo.repository.AuthRepository
import com.sweetlime.bingeamigo.repository.ReviewRepository
import com.sweetlime.bingeamigo.repository.UserRepository
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch

data class FriendReviewsState(
    val reviews: List<UserReview> = emptyList(),
    val likedReviewIds: Set<String> = emptySet(),
    val isLoading: Boolean = false
)

class FriendReviewsViewModel(
    private val authRepository: AuthRepository,
    private val userRepository: UserRepository,
    private val reviewRepository: ReviewRepository
) : ViewModel() {

    private val _state = MutableStateFlow(FriendReviewsState())
    val state: StateFlow<FriendReviewsState> = _state.asStateFlow()

    fun load(contentType: ContentType, contentId: String) {
        val uid = authRepository.currentUserId() ?: return
        _state.value = FriendReviewsState(isLoading = true)
        viewModelScope.launch {
            runCatching {
                val followingIds = userRepository.getFollowingIds(uid)
                val reviews = if (followingIds.isEmpty()) emptyList()
                else reviewRepository.getFollowingReviews(contentType.name, contentId, followingIds)
                val likedIds = reviewRepository.getLikedReviewIds(uid, reviews.map { it.docId })
                _state.value = FriendReviewsState(reviews = reviews, likedReviewIds = likedIds)
            }.onFailure {
                _state.value = FriendReviewsState()
            }
        }
    }

    fun toggleLike(review: UserReview) {
        val likerUid = authRepository.currentUserId() ?: return
        val docId = review.docId.ifBlank { return }

        val current = _state.value
        val alreadyLiked = docId in current.likedReviewIds
        val updatedLikedIds = if (alreadyLiked) current.likedReviewIds - docId else current.likedReviewIds + docId
        val updatedReviews = current.reviews.map { r ->
            if (r.docId == docId) r.copy(likeCount = maxOf(0, r.likeCount + if (alreadyLiked) -1 else 1)) else r
        }
        _state.value = current.copy(reviews = updatedReviews, likedReviewIds = updatedLikedIds)

        viewModelScope.launch {
            runCatching {
                reviewRepository.toggleLike(docId, likerUid, review.uid)
            }.onFailure {
                _state.value = current
            }
        }
    }
}